/**
 * Selection rules for the Google-Sheet picker, split out so they are unit-testable
 * without rendering the component.
 */
import { GSheetTab } from '../types';

/** Tabs that actually contain something the dialer could call. */
export function dialableTabs(tabs: GSheetTab[]): GSheetTab[] {
  return tabs.filter((t) => t.has_phone_data);
}

/** Pre-ticked selection: every dialable tab, which is the common "run all weeks" case. */
export function defaultPickedTabs(tabs: GSheetTab[]): string[] {
  return dialableTabs(tabs).map((t) => t.title);
}

/**
 * Whether the Next button should be live. A selection is valid only if every picked
 * title is still a dialable tab of the current spreadsheet — which also rejects a stale
 * selection left over from a previously connected sheet.
 */
export function canProceed(tabs: GSheetTab[], picked: string[]): boolean {
  if (picked.length === 0) return false;
  const allowed = new Set(defaultPickedTabs(tabs));
  return picked.every((title) => allowed.has(title));
}
